import React from 'react';

interface LoadingIconProps {
    width?: number;
    height?: number;
    color?: string;
    className?: string;
}

const Loading: React.FC<LoadingIconProps> = ({
    width = 24,
    height = 24,
    color = "currentColor",
    className = ""
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`animate-spin ${className}`}
        >
            <path
                d="M12 2V6M12 18V22M4.93 4.93L7.76 7.76M16.24 16.24L19.07 19.07M2 12H6M18 12H22M4.93 19.07L7.76 16.24M16.24 7.76L19.07 4.93"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Loading; 